<section class="money-manager" (click)="onClickMoneyManager.emit()">
  <img 
    src="../../../../../assets/images/money-manager-bg.png"
    alt="money manager graphic"
    class="mm-manager-img"
  > 
  <div class="mm-context">
    <p class="mm-title">Money Manager</p>
    <p class="mm-text">Track your spending with an automated budget</p>
    <a class="mm-link">
      <span class="mm-link-text">Let's go</span>
      <app-icon-arrow
        [width]="'16'"
        [height]="'16'"
      ></app-icon-arrow>
    </a>
  </div>
</section>
